module.exports = __webpack_public_path__ + "img/varilux-black.be3aef57.svg";